/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { connectLoginPopUp } from "../loginPopUp.connect";
import {
  BASE_DEV_URL,
  OTP_VERIFY,
  UNICON_THEME,
} from "../../../config/api.config";
import { Formik } from "formik";
import * as Yup from "yup";
import SVG_EyeIcon from "../../../assets/images/svgs/eye.svg?react";
import SVG_EyeOffIcon from "../../../assets/images/svgs/eyeoff.svg?react";
import SVG_LockIcon from "../../../assets/images/svgs/lock_2.svg?react";
import SVG_PromoIcon from "../../../assets/images/svgs/promo.svg?react";
import PasswordValidation from "../../PasswordValidation";
import { useLocation } from "react-router-dom";
import SVG_CallIcon from "../../../assets/images/svgs/callIcon.svg?react";
import SVG_WhatsAppIcon from "../../../assets/images/svgs/whatsappIcon.svg?react";
import SVG_GoogleIcon from "../../../assets/images/svgs/google.svg?react";
import SVG_WhatsAppLoginIcon from "../../../assets/images/svgs/whatsAppLogin.svg?react";
import CountryCodeDropdown, {
  mobileFlag,
  mobileLengths,
} from "../CountryCodeDrpodown";
import { useClickSound } from "../../ClickSoundProvider/ClickSoundProvider";
import { useSelector } from "react-redux";

const SignUpTab = ({ actions, onDidDismiss, signUp, logo }) => {
  const location = useLocation();
  const [isSending, setIsSending] = useState(false);
  const [hideFirstPass, setHideFirstPass] = useState(false);
  const [hideSecondPass, setHideSecondPass] = useState(false);
  const [showPassValidation, setShowPassValidation] = useState(false);
  const [showPasswordRules, setShowPasswordRules] = useState(false);
  const [orderID, setOrderID] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [checkVerify, setCheckVerify] = useState(false);
  const [userName, setUserName] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const referCode = queryParams.get("referCode");

  const promotions = useSelector(
    (state) => state.promotions?.whatsAppMagicLink
  );

  const initialValues = {
    countryCode: "91",
    username: "",
    mobileNum: "",
    otp: "",
    password: "",
    conPassword: "",
    promo: signUp.referCode ? signUp.referCode : referCode || "",
  };

  const validationSchema = (isOtpRequired) => {
    return Yup.object().shape({
      countryCode: Yup.string().required("Country is required"),
      mobileNum: Yup.string()
        .matches(/^\d+$/, "Phone Number must only contain digits")
        .when("countryCode", (countryCode, schema) => {
          const length = mobileLengths[countryCode] || 10;
          return schema
            .min(length, `Phone Number must be ${length} digits`)
            .max(length, `Phone Number must be ${length} digits`)
            .required("Phone Number is required");
        }),
      otp: isOtpRequired
        ? Yup.string()
            .min(6, "Otp must be 6 digits long")
            .required("Otp Required")
        : Yup.string().notRequired(),
      password: Yup.string()
        .required("Password is required")
        .min(6, "Must be at least 6 characters"),
      conPassword: Yup.string()
        .required("This field is required")
        .oneOf([Yup.ref("password"), null], "Password does not match."),
      promo: Yup.string().nullable(),
    });
  };

  useEffect(() => {
    if ("OTPCredential" in window) {
      window.addEventListener("DOMContentLoaded", () => {
        const input = document.querySelector(
          'input[autoComplete="one-time-code"]'
        );
        if (!input) return;

        navigator.credentials
          .get({
            otp: { transport: ["sms"] },
          })
          .then((otp) => {
            input.value = otp.code;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    }
  }, []);

  ////////////////   NEW SignIn ////////////////////
  const [otpSent, setOtpSent] = useState(false);
  const [isSendingNew, setIsSendingNew] = useState(false);

  const initialMinuteNew = 0,
    initialSecondsNew = 59;
  const [minutesNew, setMinutesNew] = useState(initialMinuteNew);
  const [secondsNew, setSecondsNew] = useState(initialSecondsNew);

  const mobileValidationNew = async (mobileNum, countryCode) => {
    setIsSendingNew(true);
    if (!mobileNum || mobileNum?.length < (mobileLengths[countryCode] || 10)) {
      return;
    } else {
      const data = {
        country_code: `+${countryCode || "91"}`,
        mobile: `${mobileNum}`,
      };

      await actions
        .postNumberSignUp(data)
        .then((res) => {
          if (res.status === 200) {
            if (res?.data?.status) {
              toastr.success("", `${res?.data?.msg}`);
              setOtpSent(true);
              setOrderID(res?.data?.data?.orderId);
              res?.data?.otp_expiry_time &&
                setSecondsNew(Number(res?.data?.otp_expiry_time));
            } else {
              setIsSendingNew(false);
              toastr.error("", `${res?.data?.msg}`);
            }
          }
        })
        .catch((e) => {
          setIsSendingNew(false);
          toastr.error("", `${e}`);
        });
    }
  };

  const resendOTP = async () => {
    const dataOTP = {
      orderId: orderID,
    };

    await actions
      .resendOTP(dataOTP)
      .then((res) => {
        if (res.status) {
          toastr.success("", `${res.data.msg}`);
          setOtpSent(true);
          res?.data?.otp_expiry_time &&
            setSecondsNew(Number(res?.data?.otp_expiry_time));
        }
      })
      .catch((e) => toastr.error("", `${e}`));
  };

  const verifyOtp = async (otp) => {
    setIsSendingNew(true);

    if (!orderID) {
      toastr.error("", "Please send OTP first!");
      return false;
    }

    const dataForOTP = {
      orderId: orderID,
      otp: otp,
    };

    try {
      const res = await actions.verifyOTP(dataForOTP);

      if (res.status === 200 && res?.data) {
        if (res.data.status) {
          setCheckVerify(true);
          setOtpVerified(true);
          setIsSendingNew(false);
          toastr.success("", res.data.msg || res.msg);
          return true;
        } else {
          toastr.error("", res.data.msg || res.msg);
        }
      }
    } catch (e) {
      toastr.error("", e?.data?.msg || e?.msg);
    }

    return false;
  };

  useEffect(() => {
    if (otpSent) {
      let myIntervalNew = setInterval(() => {
        if (secondsNew > 0) {
          setSecondsNew(secondsNew - 1);
        }
        if (secondsNew === 0) {
          if (minutesNew === 0) {
            clearInterval(myIntervalNew);
          } else {
            setMinutesNew(minutesNew - 1);
            setSecondsNew(59);
          }
        }
      }, 1000);
      return () => {
        clearInterval(myIntervalNew);
      };
    }
  });

  const oauth = (provider) => {
    OTPlessSignin.initiate({ channel: "OAUTH", channelType: provider });
    onDidDismiss();
  };

  const { playClick } = useClickSound();
  const onSubmit = async (values) => {
    playClick();
    if (OTP_VERIFY && !orderID) return;

    setIsSending(true);

    const data = {
      name: userName,
      user_name: userName,
      mobile: `${values.mobileNum ? values.mobileNum : ""}`,
      password: `${values.password}`,
      country_code: `+${values.countryCode || "91"}`,
    };
    if (values.promo) data.refer_code = `${values.promo.toLowerCase()}`;
    if (data.mobile == undefined || data.mobile == "" || data.mobile == null) {
      delete data.mobile;
    }

    // if (OTP_VERIFY && !checkVerify) {
    //   const otpSuccess = await verifyOtp(values.otp); // assuming otp is in values

    //   if (!otpSuccess) {
    //     setIsSending(false);
    //     return; // Stop if OTP verification fails
    //   }
    // }

    await actions
      .registerNew(data)
      .then((res) => {
        if (res.status === 200) {
          if (res?.data) {
            res?.data?.status
              ? toastr.success("", res?.data?.msg)
              : toastr.error("", res?.data?.msg || res?.msg);
          }

          if (res?.data?.status) {
            let data = {
              user_name: values.mobileNum,
              password: values.password,
              grant_type: "password",
            };
            actions.requestAuth(data);
            setIsSending(false);
            onDidDismiss(false);
            try {
              // radar start
              // try{
              //   if (window.location.search) {
              //     let s = "=";
              //     const queryString = window.location.search;
              //     const parameters = new URLSearchParams(queryString);
              //     parameters.forEach((value, key, urlParam) => {
              //       if (value === "WATER") {
              //         window.fbq('track', 'Lead');
              //       }
              //     });
              //   }
              // } catch (e) {
              //   console.log(e);
              // }
              // const endSignUp = window.srtmCommands.push({event: "track.user.registration",payload: {action: "complete",userId: res?.data?.result?.memberCode}});
              // console.log('!! endSignUp')
              // radar end
            } catch (e) {
              toastr.error("", `${e?.data?.msg || e?.msg}`);
            }
          } else {
            setIsSending(false);
          }
        }
      })
      .catch((e) => {
        setIsSending(false);
        toastr.error("", `${e?.data?.msg || e?.msg}`);
      });
  };

  const [enableWhatapp, setEnabledWhatapp] = useState(false);

  useEffect(() => {
    const fetchMagicLinkStatus = async () => {
      try {
        const response = await fetch(
          "https://sid1.platinumexch.net/api/v1/website/getWhatsAppMagicLinkStatus",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch magic link status");
        }

        const data = await response.json();
        setEnabledWhatapp(data?.data?.whatsapp_magic_link);
        // console.log("Magic link status:", data);
      } catch (error) {
        console.error("Error fetching WhatsApp magic link status:", error);
      }
    };

    fetchMagicLinkStatus();
  }, []);

  useEffect(() => {
    console.log(userName, "userNameuserName");

    const fetchUserName = async () => {
      try {
        const res = await fetch(`${BASE_DEV_URL}user/getUserNameOpen`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await res.json();
        setUserName(data?.username);
      } catch (error) {
        console.error("Error fetching user name:", error);
      }
    };

    fetchUserName();
  }, []);

  return (
    <>
      <div className="flex gap-6   h-max w-full">
        <div className=" hidden   lg:w-[50%]   w-full rounded-lg overflow-hidden">
          <img
            src={logo}
            alt="register banner"
            style={{
              filter:
                "invert(93%) sepia(83%) saturate(7422%) hue-rotate(-5deg) brightness(91%) contrast(108%)",
            }}
          />
        </div>
        <div title="register" className="flex  flex-col   gap-y-4 w-full ">
          {/* <div className="logo w-full lg:hidden flex items-center justify-center">
            <img
              src={logo}
              alt="logo"
              style={{
                filter:
                  "invert(93%) sepia(83%) saturate(7422%) hue-rotate(-5deg) brightness(91%) contrast(108%)",
              }}
            />
          </div> */}
          <div className="w-full  max-h-[35px] flex items-center justify-between">
            <p
              className={`  ${
                UNICON_THEME ? "text-black" : ""
              } text-text_color_loginTextColor font-bold text-[22px]`}
            >
              Sign Up
            </p>
            <div className="relative overflow-hidden max-h-[40px] max-w-[141.428571429px]  flex items-center justify-end">
              <img
                src={logo}
                className="md:h-[30px] h-[28px]"
                alt="register banner"
                style={{
                  filter: " hue-rotate(-5deg) brightness(91%) contrast(108%)",
                }}
              />
            </div>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema(OTP_VERIFY, otpVerified)}
            onSubmit={onSubmit}
          >
            {({
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              errors,
              touched,
            }) => (
              <form
                className="w-full gap-y-4 flex flex-col"
                autoComplete="off"
                onSubmit={handleSubmit}
              >
                <div title="signUpForm" className=" w-full">
                  <>
                    <div className="flex w-full items-center py-2 bg-bg_BgGray rounded-lg border">
                      <span
                        id="dropdown-phone-button"
                        className="flex-shrink-0 z-10 text-text_Quaternary inline-flex items-center pl-2 pr-1 text-sm sm:text-md font-normal text-center"
                      >
                        +{values.countryCode || "91"}
                        <div className="relative overflow-hidden w-max h-max ml-1">
                          <span className="f32">
                            <div
                              className={`flag ${
                                mobileFlag[values.countryCode] || "in"
                              } w-full`}
                            ></div>
                          </span>
                        </div>
                        <CountryCodeDropdown
                          countryType={values.countryCode}
                          handleCountryType={(countryCode) => {
                            handleChange({
                              target: {
                                name: "countryCode",
                                value: countryCode,
                              },
                            });
                          }}
                        />
                      </span>
                      <input
                        id="mobile-no-input"
                        className="block focus:outline-none  focus:bg-inherit w-full font-lato bg-bg_BgGray rounded-none text-text_Ternary  pr-2 text-sm xs:text-md"
                        placeholder="895XX6XXXX"
                        inputMode="numeric"
                        autoComplete="off"
                        type="tel"
                        name="mobileNum"
                        maxLength={mobileLengths[values.countryCode] || 10}
                        value={values.mobileNum}
                        onChange={(e) => {
                          const onlyNums = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                          handleChange({
                            target: {
                              name: "mobileNum",
                              value: onlyNums,
                            },
                          });
                        }}
                        onBlur={handleBlur}
                      />
                      {/* {OTP_VERIFY && (
                        <div className="">
                          <button
                            disabled={
                              !values.mobileNum ||
                              values.mobileNum.length < 10 ||
                              !values.mobileNum.match(
                                /^\d+$/,
                                "Phone Number must only contain digits"
                              ) ||
                              otpSent
                            }
                            className=" leading-normal overflow-hidden  duration-150  font-lato-bold  h-fit bg-bg_Primary text-text_Quaternary transition-all ease-in-out text-xs whitespace-nowrap mr-1 py-1 px-3 rounded active:scale-[0.98] active:opacity-95 disabled:bg-bg_Slate500 disabled:opacity-50 font-medium relative flex items-center justify-center  cursor-pointer "
                            type="button"
                            onClick={() =>
                              !otpSent
                                ? mobileValidationNew(values.mobileNum)
                                : null
                            }
                          >
                            <span className=" ">Get OTP</span>
                            <span className=" shimmer"></span>
                          </button>
                        </div>
                      )} */}
                    </div>
                    <div
                      id="phoneNumberValidations"
                      className=" flex w-full items-center justify-between mt-1 px-1"
                    >
                      <span className=" text-xs text-text_Danger">
                        {errors.mobileNum && touched.mobileNum
                          ? errors.mobileNum
                          : ""}
                      </span>
                      <span className=" text-xs text-text_Primary">
                        {values?.mobileNum?.length}/
                        {mobileLengths[values.countryCode] || 10}
                      </span>
                    </div>
                  </>

                  {OTP_VERIFY && (
                    <div className="w-full grid  grid-cols-1 xs:grid-cols-2 gap-2 overflow-hidden py-2 ">
                      {/* <button
                        type="button"
                        className="w-full text-white border min-h-[36px]  transition-all ease-in-out text-xs whitespace-nowrap mr-1 py-2 sm:py-2.5 px-3 rounded-md font-medium shadow-sm  flex items-center justify-center gap-x-2 active:scale-[0.98] active:opacity-95 cursor-pointer bg-bg_color_input_bg border-border_color_primary1 text-text_color_loginInputTextColor disabled:opacity-60 disabled:cursor-not-allowed"
                        disabled={
                          !values.mobileNum ||
                          values.mobileNum.length <
                            (mobileLengths[values.countryCode] || 10) ||
                          !values.mobileNum.match(
                            /^\d+$/,
                            "Phone Number must only contain digits"
                          ) ||
                          otpSent
                        }
                        onClick={() =>
                          !otpSent
                            ? mobileValidationNew(
                                values.mobileNum,
                                values.countryCode
                              )
                            : null
                        }
                      >
                        <span>
                          <SVG_CallIcon />
                        </span>
                        <span>SMS OTP</span>
                        <span className=" shimmer"></span>
                      </button> */}
                      <button
                        disabled={
                          !values.mobileNum ||
                          values.mobileNum.length <
                            (mobileLengths[values.countryCode] || 10) ||
                          !values.mobileNum.match(
                            /^\d+$/,
                            "Phone Number must only contain digits"
                          )
                        }
                        // onClick={() =>
                        //   !otpSent
                        //     ? mobileValidationNew(
                        //         values.mobileNum,
                        //         values.countryCode
                        //       )
                        //     : null
                        // }
                        type="button"
                        className={`w-full h-fit text-xs sm:text-sm border  transition-all ease-in-out whitespace-nowrap p-2 rounded-lg disabled:opacity-70 font-medium flex gap-x-2.5 items-center justify-center font-bold overflow-hidden ${
                          UNICON_THEME ? "bg-white" : "bg-bg_color_input_bg"
                        }  border-border_color_primary1   text-text_color_loginInputTextColor relative  `}
                      >
                        <SVG_CallIcon
                          stroke={UNICON_THEME ? "#860c21" : "gray"}
                        />

                        <span className="text-white">SMS OTP</span>
                        <span className="shimmer" />
                      </button>

                      <button
                        type="button"
                        className={`w-full h-fit text-xs sm:text-sm  transition-all ease-in-out whitespace-nowrap p-2 rounded-lg disabled:opacity-70 font-medium flex gap-x-2.5 items-center justify-center font-bold overflow-hidden text-text_color_loginTextColor   
                           ${
                             UNICON_THEME == true
                               ? "bg-bg_color_LoginBtnBgColor-unicon text-white"
                               : "bg-bg_color_LoginBtnBgColor"
                           } border-border_color_brand_secondary1 relative  `}
                        disabled={
                          !values.mobileNum ||
                          values.mobileNum.length <
                            (mobileLengths[values.countryCode] || 10) ||
                          !values.mobileNum.match(
                            /^\d+$/,
                            "Phone Number must only contain digits"
                          )
                        }
                        onClick={() =>
                          mobileValidationNew(
                            values.mobileNum,
                            values.countryCode
                          )
                        }
                      >
                        <span>
                          <SVG_WhatsAppIcon />
                        </span>
                        <span>WhatsApp OTP</span>
                        <span className="shimmer" />
                      </button>
                    </div>
                  )}

                  {OTP_VERIFY && (
                    <>
                      <div className="flex w-full items-center border p-1 bg-bg_BgGray rounded-lg mt-2">
                        <input
                          id="otpSignUp"
                          className="block  focus:outline-none  focus:bg-inherit w-full font-lato rounded-none py-1 text-text_Ternary  px-2 text-sm xs:text-md bg-bg_BgGray"
                          placeholder="OTP"
                          inputMode="numeric"
                          disabled={
                            values.mobileNum.length <
                              (mobileLengths[values.countryCode] || 10) ||
                            !otpSent
                          }
                          autoComplete="none"
                          type="tel"
                          name="otp"
                          maxLength={6}
                          value={values.otp}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            if (values.otp.length === 6) {
                              verifyOtp(values.otp);
                            }
                          }}
                        />
                        {/* <div className="">
                          <button
                            disabled={
                              !values.otp ||
                              values.otp.length < 6 ||
                              !values.otp.match(
                                /^\d+$/,
                                "OTP must only contain digits"
                              ) ||
                              !otpSent ||
                              otpVerified
                            }
                            className=" leading-normal overflow-hidden  duration-150  font-lato-bold  h-fit bg-bg_Primary text-text_Quaternary transition-all ease-in-out text-xs whitespace-nowrap mr-1 py-1 px-3 rounded active:scale-[0.98] active:opacity-95 disabled:bg-bg_Slate500 disabled:opacity-50 font-medium relative flex items-center justify-center  cursor-pointer "
                            type="button"
                            onClick={() =>
                              otpSent ? verifyOtp(values.otp) : null
                            }
                          >
                            <span className=" ">Verify OTP</span>
                            <span className=" shimmer"></span>
                          </button>
                        </div> */}
                      </div>
                      {errors.otp && touched.otp && (
                        <div
                          id="phoneNumberValidations"
                          className=" flex w-full items-center justify-between mt-1 px-1"
                        >
                          <span className=" text-xs text-text_Danger">
                            {errors.otp && touched.otp ? errors.otp : ""}
                          </span>
                          <br />
                        </div>
                      )}

                      <div
                        id="otpTimeCount"
                        className=" flex w-full items-center justify-start mt-1 px-1"
                      >
                        {isSendingNew && (
                          <span className=" text-xs text-text_ResendOtpColor font-lato-bold">
                            <button
                              className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  flex items-center justify-center gap-x-2 cursor-pointer"
                              type="button"
                              onClick={() => {
                                if (secondsNew === 0) {
                                  resendOTP();
                                }
                              }}
                            >
                              <span className=" text-text_ResendOtpColor underline">
                                Resend OTP
                                {minutesNew === 0 && secondsNew === 0 ? null : (
                                  <>
                                    {" "}
                                    in {minutesNew}:
                                    {secondsNew < 10
                                      ? `0${secondsNew}`
                                      : secondsNew}
                                  </>
                                )}
                              </span>
                            </button>
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  <>
                    <div className="flex w-full items-center justify-between bg-bg_BgGray rounded-lg p-1 border mt-4">
                      <div className=" w-full h-full flex items-center justify-start pl-1">
                        <span className=" mb-1 py-1">
                          <SVG_LockIcon fill="var(--color-primary)" />
                        </span>
                        <span className=" w-full relative h-full">
                          <input
                            id="passwordSignUp"
                            className="block focus:outline-none focus:bg-inherit  w-full h-full py-1 rounded-none text-text_Ternary  px-2 text-sm xs:text-md font-lato bg-bg_BgGray"
                            placeholder="Password"
                            disabled={
                              values.mobileNum.length <
                                (mobileLengths[values.countryCode] || 10) ||
                              !otpSent
                            }
                            autoComplete="none"
                            type={hideFirstPass ? "text" : "password"}
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            onFocus={() => {
                              setShowPasswordRules(true);
                            }}
                            onBlur={(e) => {
                              handleBlur(e);
                              setShowPasswordRules(false);
                            }}
                          />
                          {showPasswordRules && (
                            <PasswordValidation
                              open={showPassValidation}
                              setOpen={(val) => {
                                setShowPassValidation(val);
                              }}
                              password={values.password}
                            />
                          )}
                        </span>
                      </div>
                      <span className="py-1">
                        <button
                          className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out pr-2 flex items-center justify-center cursor-pointer"
                          type="button"
                          onClick={() => {
                            setHideFirstPass(!hideFirstPass);
                          }}
                        >
                          {hideFirstPass ? <SVG_EyeOffIcon /> : <SVG_EyeIcon />}
                        </button>
                      </span>
                    </div>
                  </>

                  <>
                    <div className="flex w-full items-center justify-between  bg-bg_BgGray rounded-lg border p-1 mt-4">
                      <div className=" w-full h-full flex items-center justify-start pl-1">
                        <span className=" mb-1">
                          <SVG_LockIcon fill="var(--color-primary)" />
                        </span>
                        <input
                          id="confirmpasswordSignUp"
                          className="block  focus:outline-none focus:bg-inherit  w-full rounded-none text-text_Ternary  px-2 py-1 text-sm xs:text-md font-lato bg-bg_BgGray"
                          placeholder="Confirm Password"
                          disabled={
                            values.mobileNum.length <
                              (mobileLengths[values.countryCode] || 10) ||
                            !otpSent
                          }
                          autoComplete="none"
                          type={hideSecondPass ? "text" : "password"}
                          name="conPassword"
                          value={values.conPassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </div>
                      <span>
                        <button
                          className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out  pr-2 flex items-center justify-center cursor-pointer"
                          type="button"
                          onClick={() => {
                            setHideSecondPass(!hideSecondPass);
                          }}
                        >
                          {hideSecondPass ? (
                            <SVG_EyeOffIcon />
                          ) : (
                            <SVG_EyeIcon />
                          )}
                        </button>
                      </span>
                    </div>
                    <div
                      id="passwordValidation"
                      className=" flex w-full items-center justify-start mt-1 px-1"
                    >
                      <span className=" text-xs text-text_Danger font-lato">
                        {errors.conPassword && touched.conPassword
                          ? errors.conPassword
                          : ""}
                      </span>
                    </div>
                  </>

                  <div className="flex w-full items-center justify-between  bg-bg_BgGray rounded-lg border p-1 mt-4">
                    <div className=" w-full h-full flex items-center justify-start pl-1">
                      <span className=" mb-0">
                        <SVG_PromoIcon />
                      </span>
                      <input
                        id="promocodeSignUp"
                        className="block  focus:outline-none focus:bg-inherit  w-full rounded-none text-text_Ternary  px-2 py-1 text-sm xs:text-md font-lato bg-bg_BgGray"
                        placeholder="Enter Promocode(Optional)"
                        // disabled={values.mobileNum.length < 10}
                        autoComplete="auto"
                        type="text"
                        name="promo"
                        value={values.promo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </div>
                  </div>

                  <div title="registerSubmitBtn" className=" w-full mt-4">
                    <button
                      disabled={isSending}
                      type="submit"
                      className={`leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full text-text_Quaternary   
                      ${
                        UNICON_THEME
                          ? "bg-bg_color_LoginBtnBgColor-unicon"
                          : "bg-bg_color_LoginBtnBgColor"
                      } rounded-lg font-medium text-[12px] xs:text-[15px] py-2 flex items-center justify-center gap-x-2 disabled:bg-bg_RegisterDisabledColor cursor-pointer`}
                    >
                      <span className=" font-lato-bold font-semibold text-base ">
                        Submit
                      </span>
                      {isSending && (
                        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                          <svg
                            className="animate-spin"
                            fill="var(--color-quaternary)"
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="20px"
                            height="20px"
                            viewBox="0 0 32.707 32.707"
                            xmlSpace="preserve"
                            stroke="#ffffff"
                          >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <g>
                                <path d="M21.477,4.511c0,2.487-2.021,4.508-4.508,4.508c-2.49,0-4.509-2.021-4.509-4.508c0-2.49,2.02-4.511,4.509-4.511 C19.458,0,21.477,2.021,21.477,4.511z M16.972,27.68c-1.386-0.002-2.513,1.119-2.517,2.508c-0.003,1.391,1.117,2.518,2.505,2.52 c1.39,0.004,2.517-1.117,2.519-2.506C19.484,28.811,18.361,27.684,16.972,27.68z M31.451,17.352c0-0.906-0.734-1.641-1.641-1.641 c-0.908,0-1.644,0.732-1.644,1.641c0,0.904,0.733,1.643,1.644,1.643C30.716,18.994,31.451,18.258,31.451,17.352z M6.995,17.352 c0-1.585-1.284-2.87-2.87-2.87s-2.869,1.285-2.869,2.87c0,1.584,1.283,2.869,2.869,2.869S6.995,18.936,6.995,17.352z M26.962,7.354 c-0.504-0.506-1.319-0.504-1.825,0c-0.505,0.506-0.505,1.328,0,1.832c0.506,0.506,1.321,0.506,1.825,0S27.466,7.86,26.962,7.354z M9.973,24.354c-1.152-1.146-3.019-1.146-4.17-0.002c-1.151,1.146-1.152,3.012,0,4.16c1.152,1.148,3.018,1.15,4.168,0 C11.125,27.367,11.125,25.502,9.973,24.354z M27.251,27.631c0.658-0.662,0.658-1.734-0.002-2.396 c-0.658-0.658-1.726-0.658-2.385,0.004c-0.658,0.66-0.658,1.732,0,2.395C25.525,28.293,26.591,28.293,27.251,27.631z M10.047,10.427c1.188-1.189,1.188-3.119,0-4.311c-1.188-1.189-3.115-1.189-4.305,0c-1.188,1.189-1.188,3.119,0.001,4.311 S8.858,11.618,10.047,10.427z"></path>
                              </g>
                            </g>
                          </svg>
                        </span>
                      )}
                    </button>
                  </div>

                  <div className="w-full my-3 flex items-center gap-4">
                    <div className="h-px flex-1 bg-bg_color_quaternary3" />
                    <span className="text-text_color_loginTextColor  text-sm font-medium ">
                      Or Register With
                    </span>
                    <div className="h-px flex-1 bg-bg_color_quaternary3" />
                  </div>

                  {promotions && (
                    <div
                      title="loginWithGoogle"
                      className=" w-full flex items-center justify-between gap-x-2 mb-2"
                    >
                      <div className=" w-full flex items-center justify-center cursor-pointer">
                        <button
                          className={`inline-block text-white border-border_color_primary1 leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full font-medium text-[12px] xs:text-[15px] px-5 py-2  flex items-center justify-center gap-x-2 border rounded-lg font-lato-bold lg:text-base   ${
                            UNICON_THEME
                              ? "bg-white text-black"
                              : "bg-bg_color_primary"
                          } text-text_color_secondary  cursor-pointer`}
                          type="button"
                          // onClick={() => oauth("GMAIL")}
                        >
                          <span>
                            <SVG_GoogleIcon />
                          </span>
                          <span>Google</span>
                        </button>
                      </div>
                      <div className="w-full ">
                        <button
                          className={`inline-block text-white border-border_color_primary1 leading-normal relative overflow-hidden  transition duration-150 ease-in-out w-full font-medium text-[12px] xs:text-[15px] px-5 py-2  flex items-center justify-center gap-x-2 border rounded-lg font-lato-bold lg:text-base   ${
                            UNICON_THEME
                              ? "bg-white text-black"
                              : "bg-bg_color_primary"
                          } text-text_color_secondary  cursor-pointer`}
                          type="button"
                          onClick={() => oauth("WHATSAPP")}
                        >
                          <span>
                            <SVG_WhatsAppLoginIcon />
                          </span>
                          <span>Whatsapp</span>
                        </button>
                      </div>
                    </div>
                  )}

                  <div
                    title="registerNowButton"
                    className=" w-full flex justify-center items-center text-xs mt-4 md:text-sm lg:text-base"
                  >
                    <div className="text-white">
                      Already have an account?{" "}
                      <span
                        className="text-white text-transparent bg-clip-text font-lato-bold font-semibold underline ml-1 cursor-pointer"
                        onClick={() => {
                          actions.setTab(1);
                        }}
                      >
                        Login
                      </span>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default connectLoginPopUp()(SignUpTab);
